exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-templates-payment-style__textCenter{text-align:center}.nil-sa-templates-payment-style__centerBlock{float:none;margin:0 auto}.nil-sa-templates-payment-style__card{text-align:left;visibility:hidden}.nil-sa-templates-payment-style__card.nil-sa-templates-payment-style__cardVisible{visibility:visible}.nil-sa-templates-payment-style__card .nil-sa-templates-payment-style__inputGroup{display:block;margin-top:10px}.nil-sa-templates-payment-style__card .nil-sa-templates-payment-style__inputGroup strong{height:33px;line-height:33px}.nil-sa-templates-payment-style__card .nil-sa-templates-payment-style__inputGroup .nil-sa-templates-payment-style__input iframe{width:100%;overflow:hidden}.nil-sa-templates-payment-style__card .nil-sa-templates-payment-style__inputGroup .nil-sa-templates-payment-style__input.nil-sa-templates-payment-style__cardField{margin-right:-3px;margin-left:-3px;margin-bottom:-6px}.nil-sa-templates-payment-style__card .nil-sa-templates-payment-style__error{margin-top:3px;color:red}div.nil-sa-templates-payment-style__loading{position:absolute;width:100%;margin-top:100px;left:0;top:0}", ""]);

// exports
exports.locals = {
	"textCenter": "nil-sa-templates-payment-style__textCenter",
	"centerBlock": "nil-sa-templates-payment-style__centerBlock",
	"card": "nil-sa-templates-payment-style__card",
	"cardVisible": "nil-sa-templates-payment-style__cardVisible",
	"inputGroup": "nil-sa-templates-payment-style__inputGroup",
	"input": "nil-sa-templates-payment-style__input",
	"cardField": "nil-sa-templates-payment-style__cardField",
	"error": "nil-sa-templates-payment-style__error",
	"loading": "nil-sa-templates-payment-style__loading"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/templates/Payment/style.less
// module id = 481
// module chunks = 0